import React from "react";
import { useT, useI18n } from "@/i18n";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PolicyLayout({ ns }) {
  const t = useT();
  const { lang } = useI18n();
  const sections = t(`${ns}.sections`) || [];
  return (
    <div className="relative isolate">
      <div className="absolute inset-x-0 top-0 h-[320px] -z-10 bg-gradient-to-b from-[#111826] to-[#0B0F14]" />
      <div className="mx-auto max-w-[820px] px-5 md:px-8 py-14 md:py-20">
        <Link
          to={`/${lang}`}
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#8f96a3] hover:text-white transition"
          data-testid="policy-back"
        >
          <ArrowLeft size={14} /> {t("nav.home")}
        </Link>
        <h1 className="mt-6 text-3xl md:text-5xl font-semibold tracking-tight text-[#F1ECDE]" data-testid="policy-title">
          {t(`${ns}.title`)}
        </h1>
        <div className="mt-3 text-xs uppercase tracking-[0.22em] text-[#C9F14B]">
          {t(`${ns}.updated`)}
        </div>
        <p className="mt-6 text-[15px] leading-relaxed text-[#c8cdd6]">{t(`${ns}.intro`)}</p>

        <div className="mt-10 space-y-8">
          {Array.isArray(sections) && sections.map((s, i) => (
            <section key={i} className="space-y-3">
              <h2 className="text-lg md:text-xl font-semibold text-[#F1ECDE]">{s.h}</h2>
              <p className="text-[15px] leading-relaxed text-[#c8cdd6]">{s.p}</p>
            </section>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 text-xs text-[#8f96a3]">
          Zenithradiar S.A.S. · {t("footer.legal.cuit")} · {t("footer.legal.address")}
        </div>
      </div>
    </div>
  );
}
